<div class="comment-wrapper">
    <div class="form-wrapper">
        <input #commentInput type="text" placeholder="Add comments (optional)" [value]="commentText"
            (input)="onCommentTextChange(commentInput.value)" [disabled]="isSubmitting"
            [title]="uploadedFiles.length > 0 ? getUploadedFileNames() : ''" />
        <div class="field-label">
            <label for="file-upload" class="input-icon-sm file-upload-label" *ngIf="isFileUploadEnabled">
                <img src="../../../assets/images/file-upload.svg" alt="Upload Icon" class="icon"
                    [title]="'Upload file'">
                <input id="file-upload" type="file" multiple
                    accept=".pdf,.ppt,.pptx,.xlsx,.jpg,.jpeg,.png,.gif,.bmp,.svg,.webp"
                    (change)="onFileSelected($event)" style="display:none">
            </label>
        </div>
        <mat-form-field appearance="outline" class="resolve-feedback-dropdown">
            <mat-select [(ngModel)]="statusDisplayLabel" [compareWith]="compareStatus"
                (selectionChange)="onStatusChange($event.value)" [disabled]="isLoading" required>
                <mat-option *ngFor="let status of feedbackStatusList" [value]="status.feedback_value">
                    {{ status.feedback_value }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <button class="btn-add" (click)="onSubmit()" [disabled]="isSubmitting">
            {{ isSubmitting ? 'Submitting...' : 'Submit' }}
        </button>
    </div>
    <div *ngIf="fileSizeError" class="file-size-error">{{ fileSizeError }}</div>
    <div *ngIf="uploadedFiles.length > 0 && !isSubmitting" class="uploaded-files-list">
        <span *ngFor="let file of uploadedFiles" class="uploaded-file-name">{{ file.name }}</span>
    </div>
    <div class="comments">
        <div class="timeline-container">
            <ul class="timeline">
                <div class="timeline-before"></div>
                <ng-container *ngFor="let detail of historyDetails">
                    <li class="timeline-item" *ngIf="!detail.isUser && detail.message && detail.message.trim()">
                        <ng-container *ngTemplateOutlet="commentBlock; context: { $implicit: detail }"></ng-container>
                    </li>
                    <li class="timeline-item timeline-inverted"
                        *ngIf="detail.isUser && detail.message && detail.message.trim()">
                        <ng-container *ngTemplateOutlet="commentBlock; context: { $implicit: detail }"></ng-container>
                    </li>
                </ng-container>
                <li class="timeline-item timeline-badge-wrap">
                    <div class="timeline-badge">&nbsp;</div>
                </li>
            </ul>
            <div class="timeline-comment">Feedback Created</div>
        </div>
        <div class="clearfix"></div>
    </div>

    <ng-template #commentBlock let-detail>
        <div class="timeline-badge">&nbsp;</div>
        <div class="timeline-panel">
            <div class="inner">
                <div class="icon-name" [ngClass]="{'ai-avatar': detail.isAI}">
                    <span *ngIf="!detail.isUser">{{ getActivityInitials(detail) }}</span>
                    <span *ngIf="!detail.isAI && detail.isUser">{{detail?.first_name ? (detail.first_name[0] |
                        uppercase) :
                        ''}}{{detail?.last_name ? (detail.last_name[0] | uppercase) : ''}}</span>
                </div>
                <div class="comment-details">
                    <div class="comment-author" *ngIf="!detail.isUser">{{ getActivityCategory(detail) | uppercase }}
                        <span>{{detail.created_at |
                            relativeOrDate}}</span>
                        <span class="assigned-label">{{ getActivityCategory(detail) }}</span>
                    </div>
                    <div class="comment-author" *ngIf="detail.isUser">{{detail.first_name}}
                        <span>{{detail.created_at |
                            relativeOrDate}}</span>
                    </div>
                    <p *ngIf="!detail.hasIssueLinks">{{detail.message}}</p>
                    <p *ngIf="detail.hasIssueLinks">
                        {{detail.message}} <a class="issue-link"
                            (click)="onOpenEvaluationDialog(0)">{{detail.issuesText}}</a>
                    </p>
                    <div class="attachment" *ngIf="detail.attachment">
                        <img src="../../../assets/icons/scenario_details.svg" alt="File" class="attachment-icon">
                        <a (click)="downloadContactCenterImage($event, detail.attachment)">
                            {{ getAttachmentDisplayName(detail.attachment) }}
                        </a>
                    </div>
                </div>
            </div>
            <div class="assignee-profile">
                <span class="assignee-profile-name">{{ getAssigneeProfile(detail) | uppercase }}</span>
            </div>
        </div>

    </ng-template>
</div>